import { useState, useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { Network } from '@capacitor/network';

export function useNetworkStatus() {
  const [isConnected, setIsConnected] = useState(true);

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    // Get initial status
    Network.getStatus().then(status => {
      setIsConnected(status.connected);
    });

    // Listen for changes
    const handler = Network.addListener('networkStatusChange', status => {
      setIsConnected(status.connected);
    });

    return () => {
      handler.then(h => h.remove());
    };
  }, []);

  return { isConnected };
}
